import { Breadcrumbs } from '@platform/navigation';
import type { IPageCrumbsProps } from './IPageCrumbsProps';

/**
 * Смуга крихт над шапкою сторінки модуля (UIUX layout/breadcrumbs, прототип v4: 34px, відступи 8px 32px 0, 13px): «Робочий простір › Група ›
 * Модуль (› Розділ)» — компонент Breadcrumbs навігації. Смуга лишається й без крихт (один рівень), щоб шапка стояла там, де в прототипі.
 */
export function PageCrumbs({ items }: IPageCrumbsProps) {
  return (
    <div className="lv-page__crumbs">
      <Breadcrumbs items={items} />
    </div>
  );
}
